export enum WizardTourDismissalActions {
  SET_WIZARD_TOUR_DISMISSALS = 'SET_WIZARD_TOUR_DISMISSALS',
  CREATE_WIZARD_TOUR_DISMISSAL = 'CREATE_WIZARD_TOUR_DISMISSAL',
  DELETE_WIZARD_TOUR_DISMISSAL = 'DELETE_WIZARD_TOUR_DISMISSAL',
}
